/**
 * @file useSectionLookWarnings.ts
 * @description Предупреждения об оформлении формы секции и размеры её файлов
 * (phase19.16, партия SB120, этап 1; uiux-sb120-stage1 §6; данные
 * db-design-sb120-stage1.md §4). Считаются по форме (не по сохранённому
 * блоку), чтобы «!» у группы и строка в списке замечаний менялись сразу.
 * Размеры файлов — из карты `media` страницы, запасной путь — замер.
 */

import { sectionLookWarnings, type SectionLookWarning, type SectionMediaSizes, type SectionPayload, type SiteTheme } from "@chaiberi/shared";
import { useMemo } from "react";

import { useMediaSizes } from "./useMediaSizes";
import type { SitePageDetail } from "../../lib/api-site-pages";
import { sectionMediaIds, warningTheme } from "../../lib/site-builder/look-warnings";

export function useSectionLookWarnings(
  payload: SectionPayload,
  theme: SiteTheme | null,
  /** Карта `media` ответа страницы кабинета (размеры без замера). */
  pageMedia?: SitePageDetail["media"],
): { warnings: SectionLookWarning[]; mediaSizes: SectionMediaSizes } {
  const ids = useMemo(() => sectionMediaIds(payload), [payload]);
  const mediaSizes = useMediaSizes(ids, pageMedia);
  const warnings = useMemo(() => {
    try {
      return sectionLookWarnings(payload, warningTheme(theme), mediaSizes);
    } catch {
      // Подсказка, а не проверка: необычная форма не должна ронять панель.
      return [];
    }
  }, [payload, theme, mediaSizes]);
  return { warnings, mediaSizes };
}
